import { render, staticRenderFns } from "./c_tab_radio.vue?vue&type=template&id=fcb32a2e&scoped=true"
import script from "./c_tab_radio.vue?vue&type=script&lang=js"
export * from "./c_tab_radio.vue?vue&type=script&lang=js"
import style0 from "./c_tab_radio.vue?vue&type=style&index=0&id=fcb32a2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb32a2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb32a2e')) {
      api.createRecord('fcb32a2e', component.options)
    } else {
      api.reload('fcb32a2e', component.options)
    }
    module.hot.accept("./c_tab_radio.vue?vue&type=template&id=fcb32a2e&scoped=true", function () {
      api.rerender('fcb32a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_tab_radio.vue"
export default component.exports